import { i18n } from "@/i18n/";

const applicantType = [
  { id: "essential", name: i18n.t("organiser_essential") },
  { id: "logistic", name: i18n.t("organiser_logistic") },
  { id: "both", name: i18n.t("organiser_both") },
  { id: "none", name: i18n.t("organiser_none") }
];

const organizationType = [
  { id: "logistic", name: i18n.t("organiser_logistic") },
  { id: "essential", name: i18n.t("organiser_essential") }
];

const internationalType = [
  {
    id: "international",
    name: "międzynarodowy",
    help:
      "wydarzenie edukacyjne organizowane przez podmiot trzeci, skierowane do delegatów (uczestników pasywnych) z przynajmniej dwóch różnych krajów"
  },
  {
    id: "national",
    name: "krajowy",
    help:
      "wydarzenie edukacyjne organizowane przez podmiot trzeci, skierowane do delegatów (uczestników pasywnych) wyłącznie z Polski"
  }
];

const eventAreaType = [
  {
    id: "md",
    name: i18n.t("event_area_md")
  },
  {
    id: "ivd",
    name: i18n.t("event_area_ivd")
  },
  {
    id: "both",
    name: i18n.t("event_area_both")
  },
  {
    id: "none",
    name: i18n.t("event_area_none")
  }
];

const eventType = [
  {
    id: "educational",
    name: i18n.t("event_type_educational")
  },
  {
    id: "practice",
    name: i18n.t("event_type_practice"),
    help: i18n.t("event_type_practice_help")
  }
];

const editionsType = [
  { id: "once", name: i18n.t("editions_once") },
  {
    id: "first_time",
    name: i18n.t("editions_first_time"),
    help: i18n.t("editions_first_time_help")
  },
  { id: "3_or_less", name: i18n.t("editions_3_or_less") },
  { id: "4_or_more", name: i18n.t("editions_4_or_more") }
];

const audienceAmountType = [
  { id: "50_or_less", name: i18n.t("audience_50_or_less") },
  { id: "50_199", name: i18n.t("audience_50_199") },
  { id: "200_499", name: i18n.t("audience_200_499") },
  { id: "500_999", name: i18n.t("audience_500_999") },
  { id: "1000_1999", name: i18n.t("audience_1000_1999") },
  { id: "2000_or_more", name: i18n.t("audience_2000_or_more") }
];

const rangeType = [
  {
    id: "national",
    name: i18n.t("range_national"),
    help: i18n.t("range_national_help")
  },
  {
    id: "regional",
    name: i18n.t("range_regional"),
    help: i18n.t("range_regional_help")
  },
  {
    id: "voivodeship",
    name: i18n.t("range_voivodeship"),
    help: i18n.t("range_voivodeship_help")
  },
  {
    id: "local",
    name: i18n.t("range_local"),
    help: i18n.t("range_local_help")
  }
];

const voivodeshipType = [
  { id: "dolnoslaskie", name: i18n.t("region_dolnoslaskie") },
  { id: "kujawskopomorskie", name: i18n.t("region_kujawskopomorskie") },
  { id: "lubelskie", name: i18n.t("region_lubelskie") },
  { id: "lubuskie", name: i18n.t("region_lubuskie") },
  { id: "lodzkie", name: i18n.t("region_lodzkie") },
  { id: "malopolskie", name: i18n.t("region_malopolskie") },
  { id: "mazowieckie", name: i18n.t("region_mazowieckie") },
  { id: "opolskie", name: i18n.t("region_opolskie") },
  { id: "podkarpackie", name: i18n.t("region_podkarpackie") },
  { id: "podlaskie", name: i18n.t("region_podlaskie") },
  { id: "pomorskie", name: i18n.t("region_pomorskie") },
  { id: "slaskie", name: i18n.t("region_slaskie") },
  { id: "swietokrzyskie", name: i18n.t("region_swietokrzyskie") },
  {
    id: "warminskomazurskie",
    name: i18n.t("region_warminskomazurskie")
  },
  { id: "wielkopolskie", name: i18n.t("region_wielkopolskie") },
  { id: "zachodniopomorskie", name: i18n.t("region_zachodniopomorskie") }
];

const locationType = [
  {
    id: "conference",
    name: i18n.t("location_type_conference")
  },
  {
    id: "hotel_1",
    name: i18n.t("location_type_hotel_1")
  },
  {
    id: "hotel_2",
    name: i18n.t("location_type_hotel_2")
  },
  {
    id: "university",
    name: i18n.t("location_type_university")
  },
  {
    id: "hospital",
    name: i18n.t("location_type_hospital")
  },
  {
    id: "lab",
    name: i18n.t("location_type_lab")
  },
  {
    id: "ship",
    name: i18n.t("location_type_ship")
  },
  {
    id: "museum",
    name: i18n.t("location_type_museum")
  },
  {
    id: "historical",
    name: i18n.t("location_type_historical")
  },
  {
    id: "cultural",
    name: i18n.t("location_type_cultural")
  },
  {
    id: "restaurant",
    name: i18n.t("location_type_restaurant")
  },
  // {
  //   id: "lab2",
  //   name: i18n.t("location_type_lab2")
  // },
  // {
  //   id: "cadaver",
  //   name: i18n.t("location_type_cadaver")
  // },
  // {
  //   id: "lab3",
  //   name: i18n.t("location_type_lab3")
  // },
  {
    id: "other",
    name: i18n.t("location_type_other")
  }
];

const locationFeatureType = [
  { id: "none", name: i18n.t("feature_none") },
  { id: "casino", name: i18n.t("feature_casino") },
  { id: "beach", name: i18n.t("feature_beach") },
  { id: "golf", name: i18n.t("feature_golf") },
  { id: "spa", name: i18n.t("feature_spa") },
  { id: "gym", name: i18n.t("feature_gym") },
  { id: "ski", name: i18n.t("feature_ski") },
  { id: "pool", name: i18n.t("feature_pool") },
  { id: "gym2", name: i18n.t("feature_gym2") },
  { id: "other", name: i18n.t("feature_other") }
];

export {
  eventAreaType,
  applicantType,
  internationalType,
  eventType,
  editionsType,
  audienceAmountType,
  organizationType,
  rangeType,
  voivodeshipType,
  locationType,
  locationFeatureType
};
